import { render, staticRenderFns } from "./ProductMaketDataDelivery.vue?vue&type=template&id=63bf70d8&scoped=true&"
import script from "./ProductMaketDataDelivery.vue?vue&type=script&lang=js&"
export * from "./ProductMaketDataDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaketDataDelivery.vue?vue&type=style&index=0&id=63bf70d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf70d8",
  null
  
)

export default component.exports